import { createRoot } from "react-dom/client";
import "../../ui/kit/styles.ts";
import "./death.css";
import type { RoutedKey } from "../../ui/input/router.ts";
import { DeathOverlay } from "./death-overlay.tsx";
import type { DeathScreen } from "./death-screen.ts";

/**
 * Mounts the death screen (ADR-073's amendment "the respawn is the player's, and a death is said in chat", decision 8)
 * in its host, the first in the overlay root, so the chat, the HUD and every layer after it draw over it and stay
 * usable while it shows.
 *
 * @param host The page's `#death` element.
 * @param store The screen's store.
 * @example
 * mountDeath(document.getElementById("death") as HTMLElement, death);
 */
export function mountDeath(host: HTMLElement, store: DeathScreen): void {
  createRoot(host).render(<DeathOverlay store={store} />);
}

/**
 * The screen's keys, for the input router's key listener, which hears a key only while the game owns the keyboard (so
 * never while a text field has focus): Enter or Space presses the button while it is enabled, consuming the key, so
 * Enter opens no chat then; before then, and while the character lives, the key is left to the game.
 *
 * @param store The screen's store.
 * @param now Page time in ms.
 * @returns The listener.
 */
export function deathKeys(store: DeathScreen, now: () => number): (event: RoutedKey) => void {
  return (event) => {
    if (event.repeat || event.defaultPrevented || (event.key !== "Enter" && event.key !== " ")) {
      return;
    }
    if (store.press(now())) {
      event.preventDefault();
    }
  };
}
